<template>
  <VideoAccessPage
    video-title="Marker AI 6 Minute Demo"
    video-description="Quick overview of the Marker AI platform showcasing key features and how it transforms client onboarding."
    vimeo-video-id="1145888956"
    video-type="marker-demo"
  />
</template>

<script>
import VideoAccessPage from './VideoAccessPage.vue';

export default {
  name: 'MarkerDemoVideo',
  components: {
    VideoAccessPage,
  },
};
</script>
